/* eslint-disable react/jsx-props-no-spreading */
import { type FC, type ChangeEvent } from "react";
import { useFormContext } from "react-hook-form";
import * as styles from "./styles.css";

type TextAreaProps = {
  name: string;
  placeholder: string;
  requiredMessage?: string;
  isError?: boolean;
  isDisabled?: boolean;
  height?: number;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

export const TextArea: FC<TextAreaProps> = ({
  name,
  placeholder,
  requiredMessage,
  onChange,
  isError,
  isDisabled,
  height,
}) => {
  const { register, clearErrors } = useFormContext();
  const deleteErrorMessage = () => {
    clearErrors(name);
  };
  return (
    <textarea
      className={`${styles.textArea}${isError ? ` ${styles.textAreaError}` : ""}`}
      placeholder={placeholder}
      disabled={isDisabled}
      style={height ? { height: `${height}px` } : undefined}
      {...register(name, {
        required: requiredMessage,
        onChange: (e: ChangeEvent<HTMLInputElement>) => {
          if (onChange) onChange(e);
          deleteErrorMessage();
        },
      })}
    />
  );
};
